import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {TableControl} from '../../../../../common/models/TableControl';
import {DateUtil} from '../../../../../common/util/DateUtil';
import {PagedRequestDTO} from '../../../../../common/models/PagedRequestDTO';
import {ManufacturerDTO} from '../../../../models/ManufacturerDTO';
import {DisplayIcon} from 'src/app/modules/common/components';
import {ManufacturerService} from '../../../../services/manufacturer.service';
import {
  AddManufacturerDialogComponent
} from '../../../dialogs/add-manufacturer-dialog/add-manufacturer-dialog.component';
import {
  ConfirmationDialogComponent
} from '../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {detailsExpand} from '../../../../../common';
import {createFieldMap, getSortDirection} from '../../../../../common/util/Util';
import {SharedService} from '../../../../../common/services/shared-service';
import {EntityTable} from '../../../../../common/types/entity-table.enum';

@Component({
  selector: 'app-manufacturers',
  templateUrl: './manufacturers.component.html',
  styleUrls: [
    '../../../../../../../styles/global/_management-styles.scss'
  ],
  animations: [detailsExpand]
})
export class ManufacturersComponent implements OnInit, AfterViewInit {

  readonly DisplayIcon = DisplayIcon;

  manufacturerFormControl: FormControl;
  manufacturerDisplayedColumns: string[] = ['icons', 'manufacturerId', 'name'];
  manufacturerTableControl: TableControl;
  manufacturerDataSource: ManufacturerDTO[];
  manufacturerExpandedRow: ManufacturerDTO | null;

  isConfirmed = false;
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('matSort', {static: false}) tableSort: MatSort;
  @ViewChild('manufacturerSort', {static: false}) manufacturerSort: MatSort;
  @ViewChild('manufacturerPaginator', {static: false}) manufacturerPaginator: MatPaginator;
  @ViewChild('manufacturerSearch') private manufacturerSearch: ElementRef;

  constructor(
    public dialog: MatDialog,
    private sharedService: SharedService,
    private manufacturerService: ManufacturerService,
  ) {
    this.manufacturerFormControl = new FormControl('');

    this.manufacturerTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'manufacturerId',
      'desc',
      'name',
      ''
    );
  }

  ngOnInit(): void {
    this.getListOfManufacturers(this.manufacturerTableControl);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.manufacturerSearch.nativeElement.focus(), 0);
  }

  getListOfManufacturers(tableControl: TableControl): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblManufacturer;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(
      tableControl.sortDirection
    );
    pagedRequestDTO.fieldMap = createFieldMap(
      tableControl.filterField,
      tableControl.filterValue
    );

    this.manufacturerService.getListOfManufacturers(pagedRequestDTO).subscribe(
      (response) => {
        this.manufacturerDataSource = response.resultList;
        this.manufacturerTableControl.length = response.totalRecords;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  pageChanged($event: PageEvent) {
    this.manufacturerTableControl.pageNumber = $event.pageIndex;
    this.manufacturerTableControl.pageSize = $event.pageSize;
    this.getListOfManufacturers(this.manufacturerTableControl);
  }

  sortData($event: Sort) {
    if (this.manufacturerPaginator != null) {
      this.manufacturerPaginator.firstPage();
    }
    this.manufacturerTableControl.pageNumber = 0;
    this.manufacturerTableControl.sortField = $event.active;
    this.manufacturerTableControl.sortDirection = $event.direction;
    this.getListOfManufacturers(this.manufacturerTableControl);
  }

  onInputChangedFilterData(filterField: string) {
    if (this.manufacturerPaginator != null) {
      this.manufacturerPaginator.firstPage();
    }
    this.manufacturerTableControl.pageNumber = 0;
    this.manufacturerTableControl.filterField = filterField;
    this.manufacturerTableControl.filterValue = this.manufacturerFormControl.value;
    this.getListOfManufacturers(this.manufacturerTableControl);
  }

  deleteEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;

      if (isConfirmed) {
        this.manufacturerService.deleteManufacturer(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`Manufacturer ${id} deleted`, 'Dismiss');
            this.getListOfManufacturers(this.manufacturerTableControl);
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  editEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    this.openManufacturerDialog(id);
  }

  openManufacturerDialog(id?: number) {
    const dialogRef = this.dialog.open(AddManufacturerDialogComponent, {
      width: '40vw',
      data: id
    });

    dialogRef.afterClosed().subscribe(
      () => {
        this.getListOfManufacturers(this.manufacturerTableControl);
      },
      (error) => {
        this.sharedService.openErrorDialog(error.message);
      }
    );
  }

}
